"use client";

import Link from "next/link";
import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { FiPhone } from "react-icons/fi";
import { GrChatOption } from "react-icons/gr";

import BookAppointmentButton from "./BookAppointmentButton";
import CallNowButton from "./CallNowButton";
import { createWhatsAppUrl, trackWhatsAppClick } from "./whatsappTracking";

const WHATSAPP_NUMBER = "+919000566767";
const WHATSAPP_URL = createWhatsAppUrl(WHATSAPP_NUMBER);

interface QuickContactButtonsProps {
  phoneNumber?: string;
  appointmentUrl?: string;
  layout?: "row" | "column" | "grid";
  showCall?: boolean;
  showAppointment?: boolean;
  showWhatsApp?: boolean;
  callButtonText?: string;
  appointmentButtonText?: string;
  whatsappButtonText?: string;
  className?: string;
}

export default function QuickContactButtons({
  phoneNumber = "+919000566767",
  appointmentUrl = "/appointment",
  layout = "row",
  showCall = true,
  showAppointment = true,
  showWhatsApp = true,
  callButtonText = "Call Us Now",
  appointmentButtonText = "Book Appointment",
  whatsappButtonText = "WhatsApp Us",
  className = "",
}: QuickContactButtonsProps) {
  const handleWhatsAppClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    // GTM event tracking
    trackWhatsAppClick("inline-widget");
    // Open WhatsApp
    window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer");
  };

  const layoutClasses = {
    row: "flex flex-row flex-wrap justify-center gap-4",
    column: "flex flex-col items-center gap-4",
    grid: "grid grid-cols-1 md:grid-cols-3 gap-4",
  };

  return (
    <div className={`mx-auto w-full ${layoutClasses[layout]} ${className}`}>
      {showCall && (
        <CallNowButton
          name={callButtonText}
          bgColor="bg-green-500"
          textColor="text-white"
          textHoverColor="hover:text-violet-950"
          hoverColor="hover:bg-violet-500"
          href={`tel:${phoneNumber}`}
        />
      )}

      {showAppointment && (
        <Link href={appointmentUrl}>
          <BookAppointmentButton
            name={appointmentButtonText}
            bgColor="bg-violet-950"
            textColor="text-white"
            textHoverColor="hover:text-violet-950"
            hoverColor="hover:bg-violet-500"
          />
        </Link>
      )}

      {showWhatsApp && (
        <a
          href={WHATSAPP_URL}
          onClick={handleWhatsAppClick}
          className="group relative inline-flex items-center justify-center rounded-sm bg-[#25D366] p-2 px-4 py-2 transition duration-500 ease-in-out hover:bg-[#20BA5A]"
        >
          <FaWhatsapp size={20} className="mr-2 text-white" />
          <span className="px-4 py-2 text-center font-bold text-white hover:text-violet-950">
            {whatsappButtonText}
          </span>
        </a>
      )}
    </div>
  );
}

